/* eslint class-methods-use-this: 0 */
import * as apiUtils from 'client/api/v2/apiUtils';
import CollectionApi from 'client/api/v2/CollectionApi';

class ApplicationTemplateApi extends CollectionApi {
  constructor() {
    super('/api/application-templates', {
      skip: 0,
      limit: 100,
      sort: 'name', // Prepend with a '-' to reverse default sort direction
      search: {
        fields: ['name', 'displayName', 'keywords'],
        searchTerm: '',
      },
    });
  }

  setFilterTerm(params, filters = []) {
    return apiUtils.setFilterTerm(params, filters);
  }
}

export default new ApplicationTemplateApi();
